import { jsx as _jsx } from "react/jsx-runtime";
import { ToastContext } from '#pplx/frontend/aether/toasts/context/ToastContext.js';
import { useToastStore } from '#pplx/frontend/aether/toasts/store/useToastStore.js';
import { memo, useCallback, useMemo } from 'react';
const selector = (store) => ({
    addToast: store.addToast,
    updateToast: store.updateToast,
    closeToast: store.closeToast,
    closeAllToasts: store.closeAllToasts,
});
export const ToastStateProvider = memo(function ToastStateProvider({ children, }) {
    const { addToast, updateToast, closeToast, closeAllToasts } = useToastStore(selector);
    const openToast = useCallback((params) => {
        const toast = addToast(params);
        return {
            id: toast.id,
            updateToast: (next) => {
                updateToast({ id: toast.id, params: next });
            },
            closeToast: () => {
                closeToast({ id: toast.id });
            },
        };
    }, [addToast, closeToast, updateToast]);
    const closeToastById = useCallback((id) => {
        closeToast({ id });
    }, [closeToast]);
    const contextValue = useMemo(() => ({ openToast, closeToast: closeToastById, closeAllToasts }), [closeAllToasts, closeToastById, openToast]);
    return _jsx(ToastContext.Provider, { value: contextValue, children: children });
});
//# sourceMappingURL=ToastStateProvider.js.map